define('globals',[
  "jquery",
  "underscore"
], function ($, _) {
  "use strict";

  var globals = {};

  globals.options = {
    userLoggedIn: $("body").data("current-user"),
    singleLibrary: $("body").data("single-library"),

    ui: {
      wide: true,
      annotationsEnabled: $("body").data("annotations-enabled"),
      commentsEnabled: $("body").data("comments-enabled"),
      feedbackEnabled: $("body").data("feedback-enabled")
    }
  };

  globals.state = (function () {
    var saved = (_.has(window, "localStorage") &&
                 _.has(window.localStorage, "state")) ?
                JSON.parse(window.localStorage.getItem("state")) : {};

    var defaults = _.extend(globals.options, { filter: {} });

    return _.defaults(saved, defaults);
  })();

  /**
   * Check whether user is currently on cover page.
   *
   * If the "content" model has the "location" property the user is *not*
   * on the cover page.
   *
   * @returns {Boolean} whether user is currently on cover page.
   */
  globals.onCoverPage = function () {
    return !this.content.has("location");
  };

  globals.log = function (level, message) {
    console.log(level.toUpperCase() + ":" + " " + message);
  };

  globals.getLibrary = function () {
    return this.content.get("location").library;
  };

  globals.getVersion = function () {
    return this.content.get("location").version;
  };

  globals.getLanguage = function () {
    return this.content.get("location").language;
  };

  globals.getPath = function () {
    return this.content.get("location").path;
  };

  // toISOString() shim for old IE versions
  // TODO: Move somewhere else
  if (!Date.prototype.toISOString) {
    (function () {

      function pad(number) {
        var r = String(number);
        if (r.length === 1) {
          r = "0" + r;
        }
        return r;
      }

      Date.prototype.toISOString = function () {
        return this.getUTCFullYear() +
          "-" + pad(this.getUTCMonth() + 1) +
          "-" + pad(this.getUTCDate()) +
          "T" + pad(this.getUTCHours()) +
          ":" + pad(this.getUTCMinutes()) +
          ":" + pad(this.getUTCSeconds()) +
          "." + String((this.getUTCMilliseconds() / 1000).toFixed(3))
                                                         .slice(2, 5) +
          "Z";
      };
    }());
  }

  globals.getElementPosition = function (el) {
    // Reduce the height of the navbar from the top offset of the current
    // element to scroll to the element so that the bottom of the navbar
    // is aligned with the top of the element.
    var $el = _.isString(el) ? $(el) : el;
    return $el.offset().top - $(".navbar-default").height();
  };

  return globals;
});

